<div class="container-fluid service-bg from-top-pad">
    <div class="row mb-3">
        <div class="col-md-12">
            <h1>
                {{'gen_settings' | translate}}
            </h1>
        </div>
        <!-- App Version -->
        <div class="col-md-12">
            <p>
                <b>{{'gen_app_version' | translate}}:</b> <span class="pl-2 clr-sec-text">{{env.appVersion}}</span>
            </p>
        </div>
        <!-- Device Info -->
        <div class="col-md-12">
            <p>
                <b>{{'gen_device_model' | translate}}:</b> <span class="pl-2 clr-sec-text">{{deviceInfo}}</span>
            </p>
        </div>
        <!-- Help -->
        <div class="col-md-12">
            <p>
                <b>{{'gen_help' | translate}}:</b> <span class="pl-2 clr-sec-text">{{'help_url' | translate}}</span>
            </p>
        </div>


        <!-- Change Language -->
        <div class="col-md-12">
            <button class="button sm-100 mr-2" (click)="changeLanguage()">
                <i class="pr-1 fas fa-fw fa-globe"></i>
                {{"gen_language" | translate}}
            </button>
        </div>

        <!-- Accessibility Settings -->
        <div class="col-md-12">
            <i class="fa fa-universal-access fa-3x cursor-po-c" (click)="openSettings = !openSettings"></i>
        </div>
    </div>

    <!-- Subtitles Configurations -->
    <div class="animate__animated animate__fadeIn" [hidden]="!openSettings">
        <div class="row my-3">
            <div class="col-md-6">
                <p><b>{{'settings_accessibility_settings' | translate}}</b></p>
                <div class="settings-subtitles-bg">
                    <div class="test-subs" [style.background]="accessibility.bgColor">
                        <span [style.color]="accessibility.fontColor"
                            [style.fontSize]="accessibility.fontSize / 2 + 'vw'">{{'settings_font_msg' |
                            translate}}</span>
                    </div>
                    <img src="assets/images/subtitles-bg.jpg" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-2 my-3">
                <p>{{'settings_font_color' | translate}}</p>
                <div class="settings-color-boxs" [style.background]="accessibility.fontColor"
                    [(colorPicker)]="accessibility.fontColor"></div>
            </div>

            <div class="col-md-2 my-3">
                <p>{{'settings_font_bg' | translate}}</p>
                <div class="settings-color-boxs" [style.background]="accessibility.bgColor"
                    [(colorPicker)]="accessibility.bgColor"></div>
            </div>

            <div class="col-md-3 my-3">
                <p>{{'settings_font_size' | translate}}</p>
                <mat-button-toggle-group [(value)]="accessibility.fontSize">
                    <mat-button-toggle value="1.8" aria-label="Text size small">
                        A-
                    </mat-button-toggle>
                    <mat-button-toggle value="2.2" aria-label="Text size medium">
                        A
                    </mat-button-toggle>
                    <mat-button-toggle value="2.8" aria-label="Text size large">
                        A+
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
        <div class="row my-5">
            <div class="col-md-12">
                <button class="button sm-100 mr-2" (click)="saveSubsSettings()">{{'gen_save' | translate}}</button>
                <button class="button sm-100 mr-2" (click)="resetSettings()">{{'gen_reset' | translate}}</button>
                <button class="button sm-100 mr-2" (click)="cancelSettings()">{{'gen_cancel' | translate}}</button>
            </div>
        </div>
    </div>
</div>